import { call, put, takeLatest, all } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import { ReportingActionTypes } from '../actions/reportingActions';
import { reportsService } from '../../services/reportsService';
import { appsService } from '../../services/appsService';
import * as ActionTypes from '../actions/appActions';
import { CREATE_APP_PATH, ALL_APPS } from '../../utils/constants';

function* fetchReports(action) {
  try {
    const {
      payload: { startDate, endDate, shouldAppsFetching }
    } = action;

    let appName = action.payload.appName;

    if (shouldAppsFetching) {
      try {
        const apps = yield call(appsService.fetchAll);
        yield put({ type: ActionTypes.APPS_FETCH_SUCCEEDED, apps: apps });
        if (apps.length === 0) {
          yield put(push(CREATE_APP_PATH));
          return;
        }
        const isExistsApp = !!(
          appName && apps.filter(app => app.name === appName).length === 1
        );
        appName = isExistsApp ? appName : ALL_APPS;
      } catch (e) {
        yield put({ type: ActionTypes.APPS_FETCH_FAILED, error: e });
      }
    }

    const [analytics, revenues] = yield call(
      reportsService.fetchReports.bind(reportsService),
      startDate,
      endDate
    );
    yield put({
      type: ReportingActionTypes.FETCH_REPORTS_SUCCEEDED,
      data: { analytics, revenues, appName }
    });
  } catch (e) {
    yield put({ type: ReportingActionTypes.FETCH_REPORTS_FAILED, error: e });
  }
}

function* reportsRootSaga() {
  yield all([
    yield takeLatest(ReportingActionTypes.FETCH_REPORTS_REQUESTED, fetchReports)
  ]);
}

export default reportsRootSaga;



// WEBPACK FOOTER //
// ./src/redux/sagas/ReportsSaga.js